import {NlpButtonType} from "../../~store/models/Answer";

export const BUTTON_TYPES_WITH_FIXED_VALUE = [
    NlpButtonType.Text,
    NlpButtonType.RequestContact,
    NlpButtonType.RequestGeolocation
];